import React from "react";
import { Link } from "react-router-dom";
import {
  getAttachmentViewerPath,
  hasPdfAttachments,
} from "../../utils/advertisementAttachments";

const MoreDetailsAttachmentButton = ({
  item,
  variant = "healthcare",
  className = "btn btn-info text-white mt-2",
}) => {
  if (!hasPdfAttachments(item)) {
    return null;
  }

  return (
    <Link to={getAttachmentViewerPath(item.id, variant)} className={className}>
      More Details
    </Link>
  );
};

export default MoreDetailsAttachmentButton;
